<!--Options-->
<div class="GridMenu">
	<label>Format:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="FormatOption" [(ngModel)]="FormatOption">
		<option *ngFor="let o of lstFormatOptions" [ngValue]="o">
			{{ o.Desc }}
		</option>
	</select>

	<label>File to Import:</label>
	<div class="FilePickerMenu">
		<label class="InfoText">{{ ImportFile?.name }}</label>
		<button class="btn btn-primary" (click)="onSelectFile()">Select File</button>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<input id="ImportInput" name="ImportInput" type="file" style="display: none" (change)="onFileToImportChange($event)" />

	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onImport()">Import</button>
	<button [disabled]="IsProcessing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
